var map = {
	"./rex-analytics-logo.svg": "./src/assets/rex-analytics-logo.svg",
	"./svg/automation.svg": "./src/assets/svg/automation.svg",
	"./svg/data-services.svg": "./src/assets/svg/data-services.svg",
	"./svg/portal.svg": "./src/assets/svg/portal.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive \\.svg$";